var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row center-xs"},[_c('div',{staticClass:"loader"},[_c('vvv-icon',{attrs:{"customWidth":_vm.size || 60,"fillColor":"#3D9161"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }